export default "__VITE_ASSET__CoRYAFVq__"